import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { AppState } from '~/reducers';
import { useGetRoboticMowersQuery } from '../api/robotic-mowers-api';
import { setIsLoading, setItems } from '../store/robotic-mowers-reducer';

const useRoboticMowersLoader = () => {
  const wsReconnectionDate = useSelector((state: AppState) => state.app.wsReconnectionDate);
  const dispatch = useDispatch();
  const {
    isLoading,
    data: response,
    refetch,
  } = useGetRoboticMowersQuery(undefined, {
    refetchOnReconnect: true,
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    dispatch(
      setIsLoading({
        isLoading: isLoading && response === undefined,
      })
    );
  }, [dispatch, isLoading, response]);

  useEffect(() => {
    if (response?.items !== undefined) {
      dispatch(setItems({ items: response.items }));
    }
  }, [dispatch, response]);

  useEffect(() => {
    if (wsReconnectionDate !== undefined) {
      refetch();
    }
  }, [refetch, wsReconnectionDate]);
};

export { useRoboticMowersLoader };
